import { Field } from '#app/components/form/field.tsx'
import { SelectField } from '#app/components/form/select-field.tsx'

import { RECALL_EVENT_COPY } from '#app/routes/mocra+/_form+/components/recall-events/constants.ts'
import {
	type RecallEventDraft,
	type RecallEventDraftErrors,
} from '#app/routes/mocra+/_form+/components/recall-events/types.ts'

type Option = {
	readonly value: string
	readonly label: string
}

type Props = {
	readonly formId: string
	readonly draft: RecallEventDraft
	readonly errors: RecallEventDraftErrors
	readonly typeOptions: ReadonlyArray<Option>
	readonly outcomeOptions: ReadonlyArray<Option>
	readonly onDraftFieldChange: <FieldKey extends keyof RecallEventDraft>(
		field: FieldKey,
		value: RecallEventDraft[FieldKey],
	) => void
	readonly onSubmit: React.FormEventHandler<HTMLFormElement>
}

export function RecallEventForm({
	formId,
	draft,
	errors,
	typeOptions,
	outcomeOptions,
	onDraftFieldChange,
	onSubmit,
}: Props) {
	const typeDisabled = typeOptions.length <= 1
	const outcomeDisabled = outcomeOptions.length <= 1

	return (
		<form id={formId} onSubmit={onSubmit}>
			<SelectField
				labelProps={{ children: RECALL_EVENT_COPY.fields.typeLabel }}
				selectProps={{
					value: draft.type,
					onChange: (event) =>
						onDraftFieldChange(
							'type',
							event.target.value as RecallEventDraft['type'],
						),
					onValueChange: (next) =>
						onDraftFieldChange('type', next as RecallEventDraft['type']),
					disabled: typeDisabled,
				}}
				options={typeOptions}
				errors={errors.type ? [errors.type] : undefined}
			/>
			<Field
				labelProps={{ children: RECALL_EVENT_COPY.fields.yearLabel }}
				inputProps={{
					value: draft.year,
					onChange: (event) => onDraftFieldChange('year', event.target.value),
					type: 'text',
					inputMode: 'numeric',
					placeholder: '2024',
				}}
				errors={errors.year ? [errors.year] : undefined}
			/>
			<Field
				labelProps={{ children: RECALL_EVENT_COPY.fields.productLabel }}
				inputProps={{
					value: draft.product,
					onChange: (event) =>
						onDraftFieldChange('product', event.target.value),
					type: 'text',
					placeholder: 'Hydrating serum launch batches',
				}}
				errors={errors.product ? [errors.product] : undefined}
			/>
			<SelectField
				labelProps={{ children: RECALL_EVENT_COPY.fields.outcomeLabel }}
				selectProps={{
					value: draft.outcome,
					onChange: (event) =>
						onDraftFieldChange(
							'outcome',
							event.target.value as RecallEventDraft['outcome'],
						),
					onValueChange: (next) =>
						onDraftFieldChange('outcome', next as RecallEventDraft['outcome']),
					disabled: outcomeDisabled,
				}}
				options={outcomeOptions}
				errors={errors.outcome ? [errors.outcome] : undefined}
			/>
		</form>
	)
}
